<template>
    <div class="col-sm-5">
        <div class="card">
            <div class="card-body">
                <div class="col mt-0">
                    <h5 class="card-title">Cost of Sales and Marketing</h5>
                </div>
                <b-table
                    :items="artists"
                    :fields="fields"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    :per-page="perPage"
                    :current-page="currentPage"
                ></b-table>
                <b-pagination
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                    align="right"
                    aria-controls="my-table"
                ></b-pagination>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CostOfSalesAndMarketing',
    data: () => ({
        artistUrl: '/admin/dashboard/artists',
        artists: [],
        fields: ['band_name', 'email', 'last_login', 'home_location', { key:'altv', sortable: true }, { key:'aac', sortable: true },
                { key:'aal', sortable: true }, { key:'aals', sortable: true }],
        perPage: 5,
        currentPage: 1,
        sortBy: 'band_name',
        sortDesc: false,
    }),
    computed: {
      rows() {
        return this.artists.length
      },
    },
    async created () {
        const response = await axios.get(this.artistUrl)
        this.artists = response.data
    }
}
</script>
